'use strict';
var app = angular.module('limaApp');
app.controller('MainCtrl', ['$scope', 'socket', 'Auth','$http','$timeout',
function ($scope, socket, Auth, $http,$timeout) {

}]);
